import React from 'react';
import { Element } from 'react-scroll';
import { Resumebox } from '../ResumeBox/Resumebox';
import './Resumecontainer.css';

export const Resumecontainer = () => {
  return (
<Element className='resumecontainer' id='resume'>
    <h1>Resu<span className='spantag'>me</span></h1>
    <div className='resumecontainer-info'>
<Resumebox number="10th" title= "Mark:91.6%" school="Oxford Matric Hr sec School" location="Kongalnagaram"/>
<Resumebox number="12th" title= "Mark:85.0%" school="Oxford Matric Hr sec School"location="Kongalnagaram"/>
<Resumebox number="B.E" title= "Mark:83.3%" school="Dr.MCET"  location="Pollachi"/>
<Resumebox number="FSD" title= "" school="Guvi" location="Online plateform"/>
<Resumebox number="Extra-curricular" title= "NSS" school="Swachh Bharat Camp" location=""/>




    </div>

</Element>  )
}
